"use client";

import { cn } from "@gettactic/helpers";
import { cva, type VariantProps } from "class-variance-authority";
import React from "react";
import { StatusDot, type StatusDotProps } from "../StatusDot";

const statusBadgeVariants = cva("inline-flex items-center", {
  variants: {
    size: {
      sm: "gap-1.5 text-xs",
      md: "gap-2 text-sm",
      lg: "gap-2.5 text-base"
    }
  },
  defaultVariants: {
    size: "md"
  }
});

export interface StatusBadgeProps
  extends VariantProps<typeof statusBadgeVariants> {
  /** The label text to display */
  label: string;
  /** The color of the status dot */
  color: StatusDotProps["color"];
  /** Optional className for the container */
  className?: string;
  /** Optional className for the label text */
  labelClassName?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  label,
  color,
  size,
  className,
  labelClassName
}) => {
  const dotSize = size === "sm" ? "sm" : size === "lg" ? "lg" : "md";

  return (
    <span className={cn(statusBadgeVariants({ size }), className)}>
      <StatusDot color={color} size={dotSize} />
      <span className={cn("text-neutral-700", labelClassName)}>{label}</span>
    </span>
  );
};

StatusBadge.displayName = "StatusBadge";
